<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#F2994A"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C15.3096 8 14.75 8.55964 14.75 9.25V9.60156C12.4437 10.1439 10.75 12.2223 10.75 14.6667V18.5L9.66789 20.1231C9.34123 20.6131 9.69239 21.2692 10.2812 21.2692H21.7188C22.3076 21.2692 22.6588 20.6131 22.3321 20.1231L21.25 18.5V14.6667C21.25 12.2223 19.5563 10.1439 17.25 9.60156V9.25C17.25 8.55964 16.6904 8 16 8ZM14.0007 22.5C14.0007 23.6046 14.8961 24.5 16.0007 24.5C17.1052 24.5 18.0007 23.6046 18.0007 22.5H14.0007Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'reminder-icon',
  props: {
    width: {
      type: [Number, String],
      default: 32
    },
    height: {
      type: [Number, String],
      default: 32
    }
  }
}
</script>
